import { assert_is_safe_number, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { DTO__word_with_context } from '@shared/dto/+word/word_translated/DTO__word_with_context';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTOTokenCreateData extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.TOKEN_CREATE_DATA;

  /*
   * FIELDS
   */
  is_positive!: boolean;
  weight!: number;

  word_with_context!: DTO__word_with_context;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    assert_type_boolean(this.is_positive);
    assert_is_safe_number(this.weight);
  }
}
